import { render, staticRenderFns } from "./posDevice.vue?vue&type=template&id=498dcc05&scoped=true&"
import script from "./posDevice.vue?vue&type=script&lang=js&"
export * from "./posDevice.vue?vue&type=script&lang=js&"
import style0 from "./posDevice.vue?vue&type=style&index=0&id=498dcc05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498dcc05",
  null
  
)

export default component.exports